// extracted by mini-css-extract-plugin
export default {"filters-dropdowns-wrapper":"filters-dropdowns_filters-dropdowns-wrapper__F6Jim"};